const Benefits = () => {
  return (
    <div className="container-beneficios" id="beneficios">
      <h3 className="title-beneficios text-gray-700">BENEFICIOS</h3>
      <div className="row">
        <div className="col-md-5 seguro-renta">
          Seguro de Renta Médica
        </div>

        <div className="col-md-7">
          <div className="row">
            <div className="col-md-6 convenio-banco">
              Convenio Banco <br /> Scotiabank
            </div>
            <div className="col-md-6 convenio-auto">
              Convenios con <br /> Automotoras
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 planes-medicos">
              Planes Medicos
            </div>
            <div className="col-md-6 seguro-salud">
              Seguro <br /> Complementario <br /> de Salud
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Benefits